import { Component, OnInit } from '@angular/core';
import { ApiService } from 'password-manager';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-password-manager',
  templateUrl: './password-manager.component.html',
  styleUrls: ['./password-manager.component.scss']
})
export class PasswordManagerComponent implements OnInit {

  activationKey;
  link;
  constructor(
    private apiService : ApiService, 
    private activatedRoute: ActivatedRoute,
    // private dhhpAlert: DhhpAlertComponent,
    private router: Router) { }

  ngOnInit() {
    this.apiService.apiUrl = environment.API_ENDPOINT_PLATFORM;
    this.activationKey = this.activatedRoute.snapshot.queryParamMap.get("c");
    this.link = this.activatedRoute.snapshot.queryParamMap.get("link")
    if(this.activatedRoute.snapshot.queryParamMap.get("c")){
      this.router.navigateByUrl('/PasswordManager');
    }
  }
  onDataEvent(event){
    switch(event.event){
      case 'success': 
        if(this.link == 'new'){
          // this.dhhpAlert.dhhpAlertConfirmation('Your password has been created successfully', '');
        } else {
          // this.dhhpAlert.dhhpAlertConfirmation('Your password has been updated successfully', '');
        }
        
        this.router.navigateByUrl('/dashboard');
        break;
      // case 'failure': this.dhhpAlert.dhhpAlertError('Error when resetting password', '');break;
      // case 'error': this.dhhpAlert.dhhpAlertError(event.message, '');break;
    }
  }
}
